import { usePurchaseButtonContext } from './Context'
import { HorizontalStack } from '@ztechapps/webui.util'
import { ButtonGroup } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'
import React from 'react'

export const PopupHeader = () => {
  const { actionType, setActionType } = usePurchaseButtonContext()

  return (
    <HorizontalStack className="justify-content-between">
      <ButtonGroup size="sm">
        <BusyButton
          title="Click this to create a new purchase order."
          text="New purchase order"
          icon="keyboard"
          variant={actionType === 'add-new' ? 'primary' : 'outline-primary'}
          onClick={() => setActionType('add-new')}
        />
        <BusyButton
          title="Click this to show purchase order list."
          text="Existing purchase order"
          icon="list"
          variant={actionType === 'existing' ? 'primary' : 'outline-primary'}
          onClick={() => setActionType('existing')}
        />
      </ButtonGroup>
    </HorizontalStack>
  )
}
